
import React from 'react';
import styled from '@emotion/styled';
import { css, jsx } from '@emotion/react';


const Read = () => {
    return (
        <div
            css={{
                textAlign: 'center',
                paddingTop: 60
            }}
        >
            <h2>Read</h2>
        </div>
    )
};

export default Read;